import { render, staticRenderFns } from "./lazyImg.vue?vue&type=template&id=db4d0948&scoped=true"
import script from "./lazyImg.vue?vue&type=script&lang=js"
export * from "./lazyImg.vue?vue&type=script&lang=js"
import style0 from "./lazyImg.vue?vue&type=style&index=0&id=db4d0948&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4d0948",
  null
  
)

export default component.exports